import { createSlice } from '@reduxjs/toolkit';
import { SortTypes } from 'src/screens/bookings/BookingsScreen.types';

import { InotialBookingsStateType } from '../types/bookingsTypes';
const name = 'bookings';

const INITIAL_STATE: InotialBookingsStateType = {
  bookings: [],
  filteredBookings: [],
  isBookingsLoading: false,
  isFilteredBookingsLoading: false,
  selectedStudioBoxValue: 0,
  selectedServiceBoxValue: 0,
  selectedEmployeeBoxValue: 0,
  selectedStatusBoxValue: 0,
  sortByValue: SortTypes.ID,
  searchParams: null,
  error: null,

  isCreateRequestLoading: false,
  isUpdateRequestLoading: false,
  isRemoveRequestLoading: false,
};

const bookingsSlice = createSlice({
  name,
  initialState: INITIAL_STATE,
  reducers: {
    updateSearchParams: (state, action) => {
      const { selectedStudioBox, selectedServiceBox, selectedEmployeeBox, selectedStatusBox, sortBy } = action.payload;
      state.selectedStudioBoxValue = selectedStudioBox;
      state.selectedServiceBoxValue = selectedServiceBox;
      state.selectedEmployeeBoxValue = selectedEmployeeBox;
      state.selectedStatusBoxValue = selectedStatusBox;
      state.sortByValue = sortBy;
    },

    getBookings: state => {
      state.isBookingsLoading = true;
    },
    getBookingsSuccess: (state, action) => {
      state.isBookingsLoading = false;
      state.bookings = action.payload;
    },
    getBookingsFailure: (state, action) => {
      state.isBookingsLoading = false;
      state.error = action.payload;
    },

    getFilteredBookings: (state, action) => {
      state.isFilteredBookingsLoading = true;
      state.searchParams = action.payload;
    },
    getFilteredBookingsSuccess: (state, action) => {
      state.isFilteredBookingsLoading = false;
      state.filteredBookings = action.payload;
    },
    getFilteredBookingsFailure: (state, action) => {
      state.isFilteredBookingsLoading = false;
      state.error = action.payload;
    },

    createBookings: (state, action) => {
      state.isCreateRequestLoading = true;
    },
    createBookingsSuccess: (state) => {
      state.isCreateRequestLoading = false;
    },
    createBookingsFailure: (state, action) => {
      state.isCreateRequestLoading = false;
      state.error = action.payload;
    },

    updateBookings: (state, action) => {
      state.isUpdateRequestLoading = true;
    },
    updateBookingsSuccess: state => {
      state.isUpdateRequestLoading = false;
    },
    updateBookingsFailure: (state, action) => {
      state.isUpdateRequestLoading = false;
      state.error = action.payload;
    },

    removeBookings: (state, action) => {
      state.isRemoveRequestLoading = true;
    },
    removeBookingsFailure: (state, action) => {
      state.isRemoveRequestLoading = false;
      state.error = action.payload;
    },
    removeBookingsSuccess: state => {
      state.isRemoveRequestLoading = false;
    },
  },
});

export const {
  updateSearchParams,

  getBookings,
  getBookingsFailure,
  getBookingsSuccess,

  getFilteredBookings,
  getFilteredBookingsFailure,
  getFilteredBookingsSuccess,

  createBookings,
  createBookingsSuccess,
  createBookingsFailure,

  updateBookings,
  updateBookingsSuccess,
  updateBookingsFailure,

  removeBookings,
  removeBookingsFailure,
  removeBookingsSuccess,
} = bookingsSlice.actions;

export default bookingsSlice.reducer;
